import React, { useState } from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import * as styles from "../styles/header.module.scss";
import { StaticImage } from "gatsby-plugin-image";
import { GoPlus } from "react-icons/go";
import Social from "./socialmedialinks";

const TopLevel = (props) => {
  const [menu, setMenu] = useState(true);
  const toggleMenu = () => {
    menu ? setMenu(false) : setMenu(true);
  };
  return (
    <li className={!menu ? styles.open : ""}>
      <>
        {props.sub !== null ? (
          <>
            <Link to={`/${props.first.slug}`} onClick={props.ham}>
              {props.first.title}
            </Link>{" "}
            <button
              onClick={toggleMenu}
              aria-expanded={!menu}
              aria-haspopup="true"
              aria-label="open menu"
            >
              <GoPlus />
            </button>
          </>
        ) : (
          <p>
            <Link to={`/${props.first.slug}`} onClick={props.ham}>
              {props.first.title}
            </Link>
          </p>
        )}
      </>
      {props.sub !== null ? (
        <ul style={{ height: !menu ? `${71 * props.sub.length}px` : "" }}>
          {props.sub.map((a, b) => (
            <li key={a.id}>
              <Link to={`/${a.slug}`} onClick={props.ham}>
                {a.title}
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        ""
      )}
    </li>
  );
};

const Header = (props) => {
  const data = useStaticQuery(graphql`
    query {
      links: contentfulNavigation {
        desktopNavigation {
          ... on ContentfulPage {
            id
            slug
            title
          }
        }
        hamburgerNavigation {
          id
          firstLevelLink {
            ... on ContentfulPage {
              id
              slug
              title
            }
            ... on ContentfulUniquePage {
              id
              slug
              title
            }
          }
          secondLevelLinks {
            ... on ContentfulPage {
              id
              slug
              title
            }
          }
        }
      }
    }
  `);
  return (
    <header
      className={`${styles.mainHeader} ${
        props.scrolled || props.hero === "none" ? styles.scrolled : ""
      }`}
    >
      <nav>
        <Link to="/">
          <StaticImage
            src="../images/ipumc-logo.png"
            alt="Irving Park United Methodist Church Logo"
            width={300}
            placeholder="none"
          />
          <StaticImage
            src="../images/ipumc-logo.png"
            alt="Irving Park United Methodist Church Logo"
            width={300}
            placeholder="none"
          />
        </Link>
        <div className={styles.desktopNav}>
          <ul>
            {data.links.desktopNavigation.map((edge, index) => (
              <li key={edge.id}>
                <Link to={`/${edge.slug}`}>{edge.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <button
          className={`${styles.hamburger} ${
            props.ham && props.firstLoad
              ? ""
              : !props.ham && !props.firstLoad
              ? styles.open
              : styles.reversed
          }`}
          onClick={props.toggleHam}
          aria-label="Navigation Toggle"
          aria-expanded={!props.ham}
          aria-haspopup="true"
          aria-controls="hamburger-nav-items"
        >
          <p>Menu</p>
          <div>
            <span id="line1" className={styles.line1}></span>
            <span id="line2" className={styles.line2}></span>
            <span id="line3" className={styles.line3}></span>
          </div>
        </button>
        <div
          className={`${styles.darkBackgroundOverlay} ${
            !props.ham ? styles.open : ""
          }`}
          onClick={props.closeHam}
          aria-hidden="true"
        ></div>
        <div
          className={`${styles.hamburgerNav} ${props.ham ? "" : styles.open}`}
          id="hamburger-nav-items"
        >
          <Link to="/" onClick={props.toggleHam}>
            <StaticImage
              src="../images/ipumc-icon.png"
              alt="Irving Park United Methodist Church Logo"
              width={100}
            />
          </Link>
          <ul className={styles.mobilenavcontainer}>
            {data.links.hamburgerNavigation.map((node, index) => (
              <TopLevel
                key={node.id}
                first={node.firstLevelLink}
                sub={node.secondLevelLinks}
                ham={props.toggleHam}
              />
            ))}
            <li className={styles.social}>
              <Social />
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
